import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Handshake, CreditCard, ShoppingCart, Gavel, Scale } from 'lucide-react';
const modules = [{
  icon: <BookOpen className="w-6 h-6" data-id="element-106" />,
  title: 'Legislación y Fundamentos Jurídicos',
  desc: 'Toda la normativa, doctrina y criterios legales organizados para encontrar rápidamente el respaldo jurídico que necesitás en cada reclamo.'
}, {
  icon: <Handshake className="w-6 h-6" data-id="element-107" />,
  title: 'Reclamos Administrativos Profesionales',
  desc: 'Procedimientos, estrategias y herramientas prácticas para gestionar reclamos administrativos con mayor rapidez y seguridad.'
}, {
  icon: <CreditCard className="w-6 h-6" data-id="element-108" />,
  title: 'Bancos, Tarjetas y Estafas Digitales',
  desc: 'Material especializado para resolver conflictos financieros, consumos desconocidos, fraudes electrónicos y billeteras virtuales.'
}, {
  icon: <ShoppingCart className="w-6 h-6" data-id="element-109" />,
  title: 'Compras Online, Servicios y Seguros',
  desc: 'Todo lo necesario para abordar reclamos por comercio electrónico, productos defectuosos, garantías, telefonía, internet, seguros y servicios públicos.'
}, {
  icon: <Gavel className="w-6 h-6" data-id="element-110" />,
  title: 'Litigación Judicial y Estrategias Procesales',
  desc: 'Estrategias, herramientas y recursos para preparar demandas, organizar expedientes y litigar con mayor respaldo profesional.'
}, {
  icon: <Scale className="w-6 h-6" data-id="element-111" />,
  title: 'Jurisprudencia y Casos Prácticos',
  desc: 'Fallos relevantes, criterios actuales y casos aplicados para fortalecer cada reclamo y tomar decisiones con mayor seguridad jurídica.'
}];
export const Modules = () => {
  return <section className="py-12 bg-legal-800 border-y border-legal-700" data-id="element-112">
      <div className="container mx-auto px-4" data-id="element-113">
        <div className="text-center mb-10 max-w-3xl mx-auto" data-id="element-114">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-115">
            ¿Qué incluye el Tratado?
          </h2>
        </div>

        <div className="max-w-4xl mx-auto space-y-4" data-id="element-116">
          {modules.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.08
        }} className="group flex gap-5 md:gap-6 bg-legal-900 border border-legal-700 hover:border-gold-500/50 rounded-xl p-6 md:p-7 transition-colors" data-id="element-117">
              {/* Number + icon */}
              <div className="shrink-0 flex flex-col items-center" data-id="element-118">
                <span className="font-serif text-4xl md:text-5xl font-bold text-gold-500/30 leading-none group-hover:text-gold-500/60 transition-colors" data-id="element-119">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <span className="mt-3 flex items-center justify-center w-11 h-11 rounded-lg bg-gold-500/10 text-gold-500" data-id="element-120">
                  {mod.icon}
                </span>
              </div>

              <div className="border-l border-legal-700 pl-5 md:pl-6" data-id="element-121">
                <span className="text-xs font-semibold tracking-widest uppercase text-gold-500/80" data-id="element-122">
                  Módulo {idx + 1}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white mt-1 mb-2 leading-snug" data-id="element-123">
                  {mod.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-124">{mod.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};